import * as yup from "yup";
import { locationFieldsSchema } from "../utils/locationFieldsValidation";

export const existingRFIRequestValidationSchema = yup.object().shape({
  selectedProvider: yup.object().required("Select a vendor"),
  providerContactDetails: yup.object().nullable(),

  // Sync from UI: when user selects "new-location", this is "new-location"
  rfiLocationId: yup.string().optional(),

  // Primary location required only when "new-location" is selected
  ...locationFieldsSchema("primary", {
    mode: "always",
    whenField: "rfiLocationId",
    whenIs: "new-location",
  }),

  serviceCategories: yup
    .array()
    .min(1, "Please select at least one service category.")
    .required("Questionnaire Templates must be selected"),
  expectedDate: yup
    .object({
      startDate: yup
        .date()
        .required("Expected due date is required")
        .test(
          "is-valid-date",
          "Start date must be a valid date",
          (value) => !isNaN(new Date(value).getTime())
        ),
    })
    .required("Expected due date is required"),
  additionalDetails: yup.string().notRequired(),
  contactFirstName: yup.string(),
  contactLastName: yup.string(),
  contactEmail: yup.string().email("Invalid email format"),
});
